import React from "react";
import "./ThumbGrid.css";

export default function ThumbGrid({ children }) {
  return <div className="thumb-grid">{children}</div>;
}
